import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

class MasterListController extends Controller {
  static targets = ['card', 'tab', 'timeGroup', 'emptyState']
  static values = { filter: { type: String, default: 'all' } }

  filterValueChanged () {
    this.#applyFilter()
  }

  select (e) {
    e.preventDefault()
    const status = e.currentTarget.dataset.status
    if (this.filterValue === status) {
      this.#applyFilter()
    } else {
      this.filterValue = status
    }
  }

  cardTargetConnected () {
    this.#applyFilter()
  }

  #applyFilter () {
    const filter = this.filterValue
    let visibleCount = 0

    this.cardTargets.forEach(card => {
      const match = filter === 'all' || card.dataset.status === filter
      card.style.display = match ? '' : 'none'
      if (match) visibleCount++
    })

    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.status === filter
      tab.classList.toggle('master-list__tab--active', isActive)
    })

    // Hide time groups with no visible cards
    this.timeGroupTargets.forEach(group => {
      const cards = group.querySelectorAll('[data-master-list-target="card"]')
      const hasVisible = [...cards].some(c => c.style.display !== 'none')
      group.style.display = hasVisible ? '' : 'none'
    })

    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.style.display = visibleCount > 0 ? 'none' : ''
    }
  }
}

stimulus.register('master-list', MasterListController)
